import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from '../index';
import Button from '../../Button/Button';
import Input from '../../Input/Input';
import Label from '../../InputLabel';
import style from '../Dialog.module.scss';

export default function CreateMaterial({
  handleClose,
  title,
  open,
  buttonTitle,
  saveMaterial,
  initialValues,
}) {
  const { t } = useTranslation();
  const [values, setValues] = useState({ name: '', unit: '', price: '' });

  useEffect(() => {
    setValues(initialValues
      ? {
        name: initialValues.name || '',
        unit: initialValues.unit || '',
        price: initialValues.price ?? '',
      }
      : { name: '', unit: '', price: '' });
  }, [initialValues, open]);

  const isValidPrice = values.price !== '' && Number.isFinite(Number(values.price));
  const isValid = values.name.trim() && values.unit.trim() && isValidPrice;
  const updateValue = (field) => (event) => {
    setValues({ ...values, [field]: event.target.value });
  };

  return (
    <Dialog handleClose={handleClose} open={open} title={title}>
      <div className={style.formControl}>
        <Label text={t('Material name')} htmlFor='material_name' />
        <Input
          placeholder={t('Enter material name')}
          value={values.name}
          name='material_name'
          fullWidth
          onChange={updateValue('name')}
        />
      </div>
      <div className={style.formControl}>
        <Label text={t('Unit')} htmlFor='material_unit' />
        <Input
          placeholder={t('Enter unit')}
          value={values.unit}
          name='material_unit'
          fullWidth
          onChange={updateValue('unit')}
        />
      </div>
      <div className={style.formControl}>
        <Label text={t('Price')} htmlFor='material_price' />
        <Input
          placeholder={t('Enter price')}
          value={values.price}
          name='material_price'
          type='number'
          step='any'
          fullWidth
          onChange={updateValue('price')}
        />
      </div>
      <div className={style.buttonSaveBlock}>
        <Button
          disabled={!isValid}
          onClick={() => saveMaterial({
            name: values.name.trim(),
            unit: values.unit.trim(),
            price: Number(values.price),
          })}
          fillWidth
          size='big'
        >
          {buttonTitle}
        </Button>
      </div>
    </Dialog>
  );
}
